<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <el-button-group class="mb-3"><search-form :fields="search" /></el-button-group>

    <el-table :data="funds" resource="funds">
      <el-table-column prop="id" label="编号" width="80" />
      <el-table-column align="center" header-align="center" label="贡献人" width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.user">
            <span>{{ scope.row.user.real_name }}({{ scope.row.user.level_info.level_name }})</span>
            <br />
            <span>{{ scope.row.user.mobile }}</span>
            <br />
            <span>{{ scope.row.user.idcard_no }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="order_id" label="订单号" width="190" />
      <el-table-column prop="amount" label="金额" width="100" />
      <el-table-column prop="created_at" label="添加时间" width="170" />
      <el-table-column prop="status_text" label="结算状态" width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 0" type="warning" disable-transitions>{{ scope.row.status_text }}</el-tag>
          <el-tag v-if="scope.row.status === 1" type="success" disable-transitions>{{ scope.row.status_text }}</el-tag>
          <el-tag v-if="scope.row.status === 2" type="danger" disable-transitions>{{ scope.row.status_text }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="settle_at" label="预结算" width="170" />
      <el-table-column prop="remark" label="描述" />
    </el-table>
    <div class="card-footer"><pagination :page="page" /></div>
  </el-card>
</template>

<script>
import SearchForm from '@c/SearchForm';
import Pagination from '@c/Pagination';
import { getFunds } from '@/api/funds';

export default {
  name: 'Index',
  components: {
    SearchForm,
    Pagination
  },
  data() {
    return {
      search: [
        {
          field: 'status',
          label: '结算状态',
          type: 'el-select',
          options: [{ id: 0, name: '待结算' }, { id: 1, name: '已结算' }, { id: 2, name: '结算前作废' }],
          labelField: 'name', // 默认为 name
          valueField: 'id' // 默认为 id
        },
        {
          field: 'order_id',
          label: '订单号'
        },
        {
          field: 'created_at',
          label: '获得时间',
          type: 'el-date-picker'
        }
      ],
      funds: [],
      page: null
    };
  },
  watch: {
    $route: {
      async handler(newVal) {
        const {
          data: { data, meta }
        } = await getFunds(newVal.query);
        this.funds = data;
        this.page = meta;
      },
      immediate: true
    }
  }
};
</script>
